
import MainThings from "@/index/MainThings.vue";
import WeAreHelpingWith from "@/index/WeAreHelpingWith.vue";
import { mapGetters } from "vuex";
import PhoneIcon from "@/components/icons/PhoneIcon.vue";
import IndexButton from "@/index/IndexButton.vue";
import WrenchIcon from "@/components/icons/WrenchIcon.vue";
import HowWeCanHelp from "@/index/HowWeCanHelp.vue";
import { defineComponent } from "vue";
import EstimateRepair from "@/index/EstimateRepair.vue";

export default defineComponent({
  components: {
    EstimateRepair,
    HowWeCanHelp,
    WrenchIcon,
    IndexButton,
    PhoneIcon,
    MainThings,
    WeAreHelpingWith,
  },
  computed: {
    ...mapGetters(["getPhoneNumber"]),
  },
  mounted() {
    document.title =
      "Carspot24.pl - pomagamy kierowcom rozwiązywać ich problemy";
  },
  isIndexPage: true,
});
